module.exports = "/img/45.af92d0.webp";